import { ModeLogo } from '..';
import { TeamScore } from './';

export const Banner = ({currentRoundIndex, mode, teams, turn, scores, viewingFeedback}) => {

  return (
    <header className="banner">

      <div className="banner__logo">
        <ModeLogo mode={mode} />
      </div>
      
      {teams.map((team, index) => (
        <div key={index} className={`banner__arrow banner__arrow--${index === 0 ? 'left' : 'right' } ${ turn !== index ? 'banner__arrow--hide' : ''}`}>
          <i className="fas fa-angle-double-left"></i>
        </div>
      ))}

      {teams.map((team, index) => (
        <TeamScore 
          key={index}
          active={turn === index}
          currentRoundIndex={currentRoundIndex}
          index={index}
          score={scores[index]}
          mode={mode}
          team={team}
          viewingFeedback={viewingFeedback}
        />
      ))}

    </header>
  )
}